import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["className", "tagName"];
import classNames from 'classnames';
import { useFoundationsReadinessTracking } from '../utils/useFoundationsReadinessTracking';
import AbstractTextElement from './AbstractTextElement';
import { jsx as _jsx } from "react/jsx-runtime";
export default function Small(_ref) {
  let {
      className,
      tagName = 'small'
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  useFoundationsReadinessTracking();
  return /*#__PURE__*/_jsx(AbstractTextElement, Object.assign({}, rest, {
    tagName: tagName,
    className: classNames('private-microcopy', className)
  }));
}
Small.propTypes = AbstractTextElement.propTypes;
Small.displayName = 'Small';